import { create } from 'zustand';
import { api } from '@/lib/api';

export interface PublicBranding {
  app_name: string;
  app_logo_url: string;
  app_logo_url_dark: string;
}

type BrandingState = PublicBranding & {
  loaded: boolean;
  load: (force?: boolean) => Promise<void>;
  hydrate: (partial: Partial<PublicBranding>) => void;
};

const defaults: PublicBranding = {
  app_name: 'Leftclick AG',
  app_logo_url: '',
  app_logo_url_dark: '',
};

const BANNED_APP_NAMES = new Set([
  'Leftclick Marketing',
  'LeftClick Marketing',
  'LeftClick',
  'LeftClick Team',
  'Leftclick.',
]);

export function canonicalizeAppName(name?: string): string {
  const trimmed = name?.trim() ?? '';
  if (!trimmed || BANNED_APP_NAMES.has(trimmed)) return defaults.app_name;
  return trimmed;
}

export const useBrandingStore = create<BrandingState>((set, get) => ({
  ...defaults,
  loaded: false,
  hydrate: (partial) =>
    set((s) => ({
      ...s,
      ...partial,
      app_name: canonicalizeAppName(partial.app_name ?? s.app_name),
    })),
  load: async (force) => {
    if (!force && get().loaded) return;
    try {
      const res = await api.get<{ success?: boolean; data?: PublicBranding }>('/auth/branding');
      if (res.success && res.data) {
        set({
          app_name: canonicalizeAppName(res.data.app_name),
          app_logo_url: res.data.app_logo_url?.trim() || '',
          app_logo_url_dark: res.data.app_logo_url_dark?.trim() || '',
          loaded: true,
        });
      } else {
        set({ loaded: true });
      }
    } catch {
      set({ loaded: true });
    }
  },
}));
